module.exports = __webpack_public_path__ + "media/images/rating_easiest-b8aa283b26babc64eeb652a65d43cffe.png";